import { useFeatureGate } from '@trello/feature-gate-client';

// Usage: const { headerRedesignEnabled, menuRedesignEnabled } = useIsBoardHeaderAndMenuRedesignEnabled();

export const useIsBoardHeaderAndMenuRedesignEnabled = () => {
  const { value: isPersonalProductivityEnabled } = useFeatureGate(
    'trello_personal_productivity_release',
  );

  return {
    headerRedesignEnabled: isPersonalProductivityEnabled,
    menuRedesignEnabled: isPersonalProductivityEnabled,
  };
};
